// Záměr otevření agendy z menu, který „překlene" round-trip přes Magic.
//
// Klik na položku menu pošle Magicu `desktop/click-menu-item`; Magic agendu otevře ve svém
// navigátoru a claim ji přepošle zpět Phoenixu jako `form/open`. Mezi tím si tu podržíme, JAK
// má Phoenix výslednou agendu zobrazit:
//   - `replace`  → nahradit komplet plochu (openRoot),
//   - `detached` → otevřít rovnou v samostatném (plovoucím) okně.
// Bez záměru (navigace zevnitř agendy) = běžný modal. Consume-once: vyzvedne se prvním `form/open`.

export type MenuOpenMode = 'replace' | 'detached';

export interface PendingMenuOpen {
  readonly mode: MenuOpenMode;
  /** Titulek položky menu — pro hezčí název v historii (form/open nese jen GlobalName). */
  readonly title?: string;
}

let pending: PendingMenuOpen | null = null;

/** Zaznamená záměr před odesláním `desktop/click-menu-item`. */
export function setPendingMenuOpen(mode: MenuOpenMode, title?: string): void {
  pending = { mode, title };
}

/** Vyzvedne a vymaže čekající záměr (consume-once). */
export function consumePendingMenuOpen(): PendingMenuOpen | null {
  const value = pending;
  pending = null;
  return value;
}
